import React from "react";
import {useTranslation} from "react-i18next";

export default function NoAdministrationSelectedElement() {
    const {t} = useTranslation();

    return (
        <h2>{t("ADMINISTRATION_ORDINANCES_TREEVIEW_NO_SELECTION")}</h2>
    );
}